export enum SHIPMENT_TRACKING_LEVELS {
  REQUIRED = 1,
  ENCOURAGED = 2,
  OPTIONAL = 3,
  NONE = 4,
}
